module.exports = __webpack_public_path__ + "static/nzpolice-logo-6ff09a036566a07270c6ced969dc6c0a.png";